export enum ColumnStyle {
    None = "none",
    Bottom = "bottom"
}
